
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, CanLoad, Route } from '@angular/router';
import { AauthService } from './aauth.service';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    constructor(private authService: AauthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      this.authService.checkLoggedIn();

      const url: string = state.url;
      return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      this.authService.checkLoggedIn();
      return this.canActivate(route, state);
    }

    canLoad(route: Route): boolean {
      this.authService.checkLoggedIn();

      const url = `/${route.path}`;
      return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {
        // if (this.authService.isLoggedIn) {
        //     return true;
        // }

        this.authService.loginRedirectUrl = url;
        // this.router.navigate(['/login']);

        return true;
    }
}
